import { G_runningElements } from "../../../../utils/globals/running";

/**
 * Delete trigger from `activeTriggers` map, when step finished in enter or leave mode
 * @param {MainClassProps} main
 * @param {TriggerProps} trigger
 */
const deleteActiveTriggers = (main, trigger) => {
  trigger.set("is-active", false);

  const name = /** @type {String} */ (trigger.get("name"));

  // for (const active of main.activeProperties.values()) {
  //   for (const parent of active.values()) {
  //     for (const property of parent[0]) {
  //       property[1].delete(name)
  //       // console.log(property[1].get(name).set("progress", 0));
  //     }
  //   }
  // }

  main.activeTriggers.delete(name);

  if (!main.activeTriggers.size) {
    G_runningElements.delete(main.element);
  }
};

export default deleteActiveTriggers;
